import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { DETAIL_FIELDS } from '../constants';
import { getTransportOptionLabelSx, getTransportLabelSx } from './transportTypographySx';

AdditionalDetails.propTypes = {
  details: PropTypes.object.isRequired,
  setDetail: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  labelBoxSx: PropTypes.object,
  detailsMode: PropTypes.bool,
};

export default function AdditionalDetails({ details, setDetail, disabled = false, labelBoxSx = {}, detailsMode = false }) {
  const optionLabelSx = getTransportOptionLabelSx(detailsMode);

  return (
    <Box display="flex" alignItems="flex-start">
      <Box sx={{ minWidth: 190, pr: 2, pl: 2, pt: 0.75, ...labelBoxSx }}>
        <Typography color="text.secondary" sx={getTransportLabelSx(detailsMode)}>
          Additional Details:
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          maxWidth: 600,
        }}
      >
        {DETAIL_FIELDS.map(({ label, formField }) => (
          <FormControlLabel
            key={label}
            sx={optionLabelSx}
            label={label}
            control={
              <Checkbox
                size="small"
                checked={details[formField]}
                onChange={(e) => setDetail(formField, e.target.checked)}
                disabled={disabled}
              />
            }
          />
        ))}
      </Box>
    </Box>
  );
}
